import { axios } from "@/utils/request";

// 1020701 获取我的银行卡
export function getVo(data) {
  return axios({
    url: '/userBankCard/getVo',
    method: 'post',
    data
  })
}

// 1020702 新增-修改我的银行卡
export function updateBankCard(data) {
  return axios({
    url: '/userBankCard/updateBankCard',
    method: 'post',
    data
  })
}
